import { createSlice } from '@reduxjs/toolkit'
import { fetchFNPlaceholders, fetchSavedFN, fetchSavedFNForms } from './thunks/fooNotes';


const initialState = {
    fnPlaceholders: [],
    savedFootnotes: [],
    savedFootnotesForms: [],
    isLoading: false,
    error: "",
    selectedNote: "",
    currentStep:0,
    isGeneratingFootnote: false,
    footnoteOptionsExhausted: false,
    activeTraceKey: null,
}

const footNotes = createSlice({
    name: 'FOOTNOTESSLICE',
    initialState,
    reducers: {
        setSelectedNote(state, action) {
			state.selectedNote = action.payload;
		},
    updateCurrentStep(state, action) {
			state.currentStep = action.payload;
		},
    clearCurrentStep(state) {
			state.currentStep = 0;
		},
    setGeneratingFootnote(state, action) {
			state.isGeneratingFootnote = action.payload;
		},
    setFootnoteOptionsExhausted(state, action) {
			state.footnoteOptionsExhausted = action.payload;
		},
    setActiveTraceKey(state, action) {
			state.activeTraceKey = action.payload;
		},
    },
    extraReducers: (builder) => {
        builder.addCase(fetchFNPlaceholders.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchFNPlaceholders.fulfilled, (state, action) => {
           state.fnPlaceholders = action.payload;
        })
        builder.addCase(fetchFNPlaceholders.rejected, (state, action) => {
          state.isLoading = false
          state.fnPlaceholders = null;
          state.error = action.error.message
        })
        
        builder.addCase(fetchSavedFN.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchSavedFN.fulfilled, (state, action) => {
           state.savedFootnotes = action.payload;
        })
        builder.addCase(fetchSavedFN.rejected, (state, action) => {
          state.isLoading = false
          state.savedFootnotes = null;
          state.error = action.error.message
        })

        builder.addCase(fetchSavedFNForms.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchSavedFNForms.fulfilled, (state, action) => {
           state.savedFootnotesForms = action.payload;
        })
        builder.addCase(fetchSavedFNForms.rejected, (state, action) => {
          state.isLoading = false
          state.savedFootnotesForms = null;
          state.error = action.error.message
        })
    }
});

export const { setSelectedNote,updateCurrentStep,clearCurrentStep,setGeneratingFootnote,setFootnoteOptionsExhausted,setActiveTraceKey } = footNotes.actions

export default footNotes;